import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatISOStringToReadable } from '../../../utils/dateUtils';
import { translateMembershipLevel, translateBookingStatus, translateTableStatus } from '../../../utils/stranslateUltils';
import './css/BookingDetailsModal.css';

const BookingDetailsModal = ({ booking, onClose }) => {
  const { t } = useTranslation();

  const getStatusBadge = (status) => {
    const statusClasses = {
      PENDING: 'status-pending',
      CONFIRMED: 'status-confirmed',
      COMPLETED: 'status-completed',
      CANCELLED: 'status-cancelled'
    };

    return (
      <span className={`profile-status-badge ${statusClasses[status] || ''}`}>
        {translateBookingStatus(t,status)}
      </span>
    );
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="profile-modal-header">
          <h2>{t('booking_details.title')}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="booking-info-grid">
            <div className="info-section">
              <h3>{t('booking_details.booking_info')}</h3>
              <div className="info-row">
                <span className="label">{t('booking_details.booking_datetime')}</span>
                <span className="value">{formatISOStringToReadable(booking.bookingAt)}</span>
              </div>
              <div className="info-row">
                <span className="label">{t('booking_details.num_guests')}</span>
                <span className="value">{booking.numGuests}</span>
              </div>
              <div className="info-row">
                <span className="label">{t('booking_details.status')}</span>
                <span className="value">{getStatusBadge(booking.status)}</span>
              </div>
              {booking.note && (
                <div className="info-row">
                  <span className="label">{t('booking_details.special_note')}</span>
                  <span className="value">{booking.note}</span>
                </div>
              )}
            </div>

            <div className="info-section">
              <h3>{t('booking_details.customer_info')}</h3>
              <div className="info-row">
                <span className="label">{t('booking_details.name')}</span>
                <span className="value">{booking.customer?.customerName || t('booking_details.na')}</span>
              </div>
              <div className="info-row">
                <span className="label">{t('booking_details.email')}</span>
                <span className="value">{booking.customer?.email}</span>
              </div>
              <div className="info-row">
                <span className="label">{t('booking_details.phone')}</span>
                <span className="value">{booking.customer?.phoneNumber || t('booking_details.na')}</span>
              </div>
              <div className="info-row">
                <span className="label">{t('booking_details.loyalty_points')}</span>
                <span className="value">{booking.customer?.loyaltyPoints || 0}</span>
              </div>
              <div className="info-row">
                <span className="label">{t('booking_details.membership_level')}</span>
                <span className="value">{translateMembershipLevel(t,booking.customer?.membershipLevel)}</span>
              </div>
            </div>

            {booking.tables && booking.tables.length > 0 && (
              <div className="info-section">
                <h3>{t('booking_details.table_info')}</h3>
                <div className="tables-grid">
                  {booking.tables.map((table, index) => (
                    <div key={index} className="table-card">
                      <div className="table-name">{table.tableName}</div>
                      <div className="table-capacity">{t('booking_details.capacity')} {table.capacity}</div>
                      <div className="table-status">{t('booking_details.table_status')} {translateTableStatus(t,table.status)}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="info-section">
              <h3>{t('booking_details.booking_timeline')}</h3>
              <div className="info-row">
                <span className="label">{t('booking_details.created_at')}</span>
                <span className="value">{formatISOStringToReadable(booking.createdAt)}</span>
              </div>
              <div className="info-row">
                <span className="label">{t('booking_details.last_updated')}</span>
                <span className="value">{formatISOStringToReadable(booking.updatedAt)}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="profile-modal-footer">
          <button className="close-modal-button" onClick={onClose}>
            {t('booking_details.close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingDetailsModal;